import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

const ReusableDialog = ({ title, isOpen, children, onCancel }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onCancel}>
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          {/* // Background Blur Color // */}
          <div className="fixed inset-0 bg-black/70 backdrop-blur-0" />
        </Transition.Child>

        {/* Dialog Panel */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-500"
            enterFrom="scale-95 opacity-0"
            enterTo="scale-100 opacity-100"
            leave="ease-in duration-300"
            leaveFrom="scale-100 opacity-100"
            leaveTo="scale-95 opacity-0"
          >
            <Dialog.Panel className="w-full max-w-md rounded-xl border border-zinc-200 bg-white p-6 shadow-xl dark:border-zinc-700 dark:bg-zinc-900 relative z-10">
              <button
                onClick={onCancel}
                className="absolute right-4 top-4 text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-300 z-20"
              >
                ✕
              </button>

              {title && (
                <Dialog.Title className="mb-2 text-lg text-left font-semibold text-zinc-900 dark:text-zinc-300">
                  {title}
                </Dialog.Title>
              )}

              <div className="text-sm text-zinc-700 dark:text-zinc-300">
                {children}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ReusableDialog;
